'use strict';

/**
 * Reusable slick carousel configurations
 * @example - $('.product-carousel').slick(slickConfigs.pdp)
 */

module.exports = {
    hero: {
        autoplay: true,
        autoplaySpeed: 5000,
        easing: 'swing',
        infinite: true,
        speed: 800,
        dots: true,
        slidesToShow: 1,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1079,
                settings: {
                    arrows: true,
                    rows: 0
                }
            },
            {
                breakpoint: 320,
                settings: {
                    arrows: false,
                    rows: 0
                }
            }
        ]
    },

    productTiles: {
        infinite: true,
        speed: 300,
        dots: false,
        arrows: true,
        slidesToShow: 4,
        rows: 0,
        slidesToScroll: 1
    },

    pdp: {
        infinite: true,
        speed: 400,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        adaptiveHeight: true,
        slide: '.slide:not(.more-slide)',
        responsive: [
            {
                breakpoint: 768,
                settings: 'unslick',
                rows: 0
            }
        ]
    },

    screenshots: {
        infinite: true,
        speed: 400,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        rows: 0,
        slidesToScroll: 1,
        asNavFor: '.product-screenshots-carousel'
    },

    screenshotThumbnails: {
        infinite: true,
        speed: 400,
        arrows: true,
        slidesToShow: 6,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        variableWidth: true,
        focusOnSelect: true,
        asNavFor: '.product-main-screenshot'
    },

    categoryScreenshots: {
        infinite: true,
        speed: 400,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        rows: 0,
        slidesToScroll: 1,
        asNavFor: '.category-screenshots-carousel'
    },

    categoryScreenshotThumbnails: {
        infinite: true,
        speed: 400,
        arrows: true,
        slidesToShow: 6,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        variableWidth: true,
        focusOnSelect: true,
        asNavFor: '.category-main-screenshot'
    },

    homePage: {
        infinite: false,
        speed: 400,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        adaptiveHeight: true,
        centerMode: true,
        slide: '.slide',
        responsive: [
            {
                breakpoint: 768,
                settings: 'unslick',
                rows: 0
            }
        ]
    },

    recommendationProductTiles: {
        infinite: false,
        speed: 400,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        adaptiveHeight: true,
        centerMode: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    rows: 0,
                    centerMode: false
                }
            }
        ]
    },

    addedToCartModalRecommendationProductTiles: {
        infinite: false,
        speed: 400,
        dots: true,
        arrows: false,
        slidesToShow: 2,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        adaptiveHeight: true,
        centerMode: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    rows: 0,
                    centerMode: false
                }
            }
        ]
    },
    recentlyViewedProductTiles: {
        slidesToShow: 5,
        rows: 0,
        slidesToScroll: 5,
        centerPadding: '40px',
        arrows: true,
        infinite: false,
        dots: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    rows: 0,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false
                }
            }
        ]
    },
    recommendedProductsRedesignATC: {
        slidesToShow: 2,
        rows: 0,
        slidesToScroll: 1,
        centerPadding: '40px',
        arrows: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    rows: 0,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    },
    recommendedProductsRedesignPDP: {
        slidesToShow: 6,
        rows: 0,
        slidesToScroll: 6,
        centerPadding: '10px',
        arrows: true,
        infinite: false,
        dots: true,
        responsive: [
            {
                breakpoint: 1560,
                settings: {
                    slidesToShow: 5,
                    rows: 0,
                    slidesToScroll: 5,
                    arrows: true,
                    swipe: true,
                    swipeToSlide: true,
                    touchMove: true,
                    speed: 200,
                    cssEase: 'linear'
                }
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 4,
                    rows: 0,
                    slidesToScroll: 4,
                    arrows: true,
                    swipe: true,
                    swipeToSlide: true,
                    touchMove: true,
                    speed: 200,
                    cssEase: 'linear'
                }
            },
            {
                breakpoint: 1060,
                settings: {
                    slidesToShow: 3,
                    rows: 0,
                    slidesToScroll: 3,
                    arrows: true,
                    swipe: true,
                    swipeToSlide: true,
                    touchMove: true,
                    speed: 200,
                    cssEase: 'linear'
                }
            },
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 2,
                    rows: 0,
                    slidesToScroll: 2,
                    arrows: true,
                    swipe: true,
                    swipeToSlide: true,
                    touchMove: true,
                    speed: 200,
                    cssEase: 'linear'
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1,
                    rows: 0,
                    slidesToScroll: 1,
                    arrows: true,
                    swipe: true,
                    swipeToSlide: true,
                    touchMove: true,
                    speed: 200,
                    cssEase: 'linear'
                }
            },
            {
                breakpoint: 260,
                settings: {
                    arrows: true,
                    cssEase: 'linear',
                    speed: 200,
                    rows: 0
                }
            }
        ]
    },
    productCarouselRedesign: {
        infinite: false,
        speed: 100,
        dots: false,
        slidesToShow: 5,
        rows: 0,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: true,
        vertical: true,
        responsive: [
            {
                breakpoint: 768,
                settings: 'unslick',
                rows: 0
            }
        ]
    },
    minImageCarouselRedesign: {
        infinite: false,
        speed: 100,
        dots: false,
        slidesToShow: 5,
        rows: 0,
        slidesToScroll: 5,
        arrows: false,
        vertical: true,
        responsive: [
            {
                breakpoint: 768,
                settings: 'unslick',
                rows: 0
            }
        ]
    },
    bundleIncludedCarousel: {
        infinite: false,
        speed: 400,
        dots: false,
        slidesToShow: 2,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        adaptiveHeight: true,
        centerMode: false,
        variableWidth: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 7,
                    rows: 0,
                    centerMode: false,
                    variableWidth: true,
                    arrows: true
                }
            }
        ]
    },

    gameinformerIssueCarousel: {
        infinite: false,
        speed: 400,
        dots: true,
        slidesToShow: 1,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        adaptiveHeight: true,
        variableWidth: true,
        centerMode: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    rows: 0,
                    centerMode: false,
                    arrows: false,
                    dots: true,
                    variableWidth: true
                }
            }
        ]
    },

    accountDashboardWishlistCarousel: {
        infinite: false,
        speed: 400,
        dots: false,
        arrows: false,
        slidesToShow: 2,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        adaptiveHeight: false,
        variableWidth: true,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    rows: 0,
                    centerMode: false,
                    arrows: false,
                    dots: false,
                    variableWidth: false
                }
            }
        ]
    },
    homePageRedesign: {
        carouselDefaultSettings: {
            slidesToShow: 2,
            rows: 0,
            slidesToScroll: 2,
            centerPadding: '40px',
            arrows: true,
            infinite: false
        },
        orderHistorySettings: {
            dots: false,
            arrows: false,
            vertical: true,
            slidesToShow: 3,
            rows: 0,
            slidesToScroll: 1,
            autoplay: false,
            verticalSwiping: true,
            setPosition: true
        },
        heroCarouselRedesign: {
            autoplay: true,
            autoplaySpeed: 5000,
            easing: 'swing',
            infinite: true,
            speed: 800,
            dots: false,
            arrows: true,
            centerMode: false,
            centerPadding: '0',
            slidesToShow: 1,
            rows: 0,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        dots: false,
                        rows: 0
                    }
                }
            ]
        },
        heroCarouselE2E: {
            autoplay: true,
            autoplaySpeed: 5000,
            easing: 'swing',
            infinite: true,
            speed: 800,
            dots: true,
            arrows: false,
            centerMode: false,
            centerPadding: '0',
            slidesToShow: 1,
            rows: 0,
            slidesToScroll: 1
        }
    },

    activeOffersCarousel: {
        infinite: false,
        speed: 400,
        dots: true,
        slidesToShow: 1,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        adaptiveHeight: true,
        variableWidth: true,
        centerMode: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    rows: 0,
                    centerMode: false,
                    arrows: false,
                    dots: false,
                    variableWidth: true
                }
            }
        ]
    },
    dashboardOrderItemsCarousel: {
        slidesToShow: 1,
        rows: 0,
        slidesToScroll: 1,
        centerPadding: '40px',
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    rows: 0,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    },
    dashboardRewardsCenterCarousel: {
        infinite: false,
        speed: 400,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        adaptiveHeight: true,
        variableWidth: true,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    rows: 0,
                    centerMode: false,
                    arrows: false,
                    dots: false,
                    variableWidth: true
                }
            }
        ]
    },
    accountDashboardRecommendations: {
        infinite: false,
        speed: 400,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        rows: 0,
        slidesToScroll: 1,
        mobileFirst: true,
        adaptiveHeight: false,
        centerMode: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    rows: 0,
                    centerMode: false,
                    variableWidth: false
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    rows: 0
                }
            }
        ]
    },

    cartPlpRecommendCarousel: {
        slidesToShow: 4,
        rows: 0,
        slidesToScroll: 1,
        centerPadding: '40px',
        arrows: true,
        infinite: false,
        rows: 0,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    rows: 0,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    },

    rotatingHeaderBanner: {
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        speed: 300,
        dots: false,
        arrows: false,
        fade: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        rows: 0
    }
};
